import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "pos-container" };
const _hoisted_2 = { class: "pos-main-content" };
const _hoisted_3 = { class: "search-section" };
const _hoisted_4 = { class: "search-container" };
const _hoisted_5 = ["placeholder"];
const _hoisted_6 = { class: "products-container" };
const _hoisted_7 = { class: "pos-invoice-section" };
import { ref, computed, onMounted, onUnmounted, watch } from "vue";
import { useStore } from "vuex";
import CategoryNavigation from "../components/CategoryNavigation.vue";
import ProductMenu from "../components/ProductMenu.vue";
import OrderInvoice from "../components/OrderInvoice.vue";
import ProductCustomizationModal from "../modals/ProductCustomizationModal.vue";
import SaladCustomizationModal from "../modals/SaladCustomizationModal.vue";
import PastaCustomizationModal from "../modals/PastaCustomizationModal.vue";
import PizzaCustomizationModal from "../modals/PizzaCustomizationModal.vue";
import { listeCategorieActive, listeRestaurantProduct, listeRestaurantCategorie, getActiveCategories, getProductsByCategory, getAllIngredients, getRestaurantDetails, searchActiveProducts, } from "@/service/api";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import { UserGeneralKey, UserRole } from "@/models/user.generalkey";
import { useToast } from "vue-toastification";
import { useI18n } from "vue-i18n";
import { calculateItemTotalPrice } from "@/utils/priceCalculations";
export default /*@__PURE__*/ _defineComponent({
    __name: 'POSMain',
    setup(__props) {
        const store = useStore();
        const toast = useToast();
        const { t, locale } = useI18n();
        const searchQuery = ref("");
        const isSearching = ref(false);
        const selectedCategory = ref("");
        let searchTimeout = null;
        const showProductModal = ref(false);
        const selectedProduct = ref(null);
        const selectedProductSize = ref(null);
        const showSaladModal = ref(false);
        const selectedSaladProduct = ref(null);
        const selectedSaladSize = ref(null);
        const showPastaModal = ref(false);
        const selectedPastaProduct = ref(null);
        const selectedPastaSize = ref(null);
        const showPizzaModal = ref(false);
        const selectedPizzaProduct = ref(null);
        const selectedPizzaSize = ref(null);
        const isLoading = ref(false);
        const isLoadingProducts = ref(false);
        const isLoadingIngredients = ref(false);
        const categories = ref([]);
        const products = ref([]);
        const ingredients = ref([]);
        const userRole = ref(null);
        const restaurantID = ref(null);
        const newOrderTransactionReference = ref("");
        const showNewOrderModal = ref(false);
        const parsePhpSerializedArray = (serialized) => {
            try {
                const arrayMatch = serialized.match(/^a:(\d+):\{/);
                if (!arrayMatch)
                    return [];
                const count = parseInt(arrayMatch[1]);
                const items = [];
                const itemRegex = /i:\d+;s:(\d+):"([^"]+)";/g;
                let match;
                while ((match = itemRegex.exec(serialized)) !== null) {
                    const length = parseInt(match[1]);
                    const value = match[2];
                    if (value.length === length) {
                        items.push(value);
                    }
                }
                return items;
            }
            catch (error) {
                return [];
            }
        };
        const cart = computed(() => store?.getters?.["cart/cart"] || []);
        const cartTotal = computed(() => store?.getters?.["cart/cartTotal"] || 0);
        const cartCount = computed(() => store?.getters?.["cart/cartCount"] || 0);
        const currentOrderType = computed(() => store?.getters?.["orderType/selectedOrderType"] || "dine_in");
        const orderSummary = computed(() => {
            const subtotal = cart.value.reduce((sum, item) => sum + (item.totalPrice || 0), 0);
            const tax = subtotal * 0.026;
            const total = subtotal;
            return {
                subtotal: subtotal,
                tax,
                total,
                items: cart.value,
            };
        });
        const getSpecializedCategoryType = (product) => {
            const category = product.categorieID;
            if (!category)
                return "none";
            if (Number(category.prio) === 1 || category.is_recommended === 1 || category.is_recommended === true) {
                return "pizza";
            }
            return "none";
        };
        const requiresSpecializedModal = (product) => {
            return getSpecializedCategoryType(product) !== "none";
        };
        const handleCategoryChange = async (categoryId) => {
            searchQuery.value = "";
            isSearching.value = false;
            selectedCategory.value = categoryId;
            await fetchProducts(categoryId);
        };
        const handleCustomizeProduct = (data) => {
            const { product, selectedSize } = data;
            const productType = getSpecializedCategoryType(product);
            switch (productType) {
                case "salad":
                    openSaladModal(product, selectedSize);
                    break;
                case "pasta":
                    openPastaModal(product, selectedSize);
                    break;
                case "pizza":
                    openPizzaModal(product, selectedSize);
                    break;
                default:
                    selectedProduct.value = product;
                    selectedProductSize.value = selectedSize;
                    showProductModal.value = true;
                    break;
            }
        };
        const handleCreatePizza = (selectedBase, selectedSize, sizeId) => {
        };
        const openSaladModal = (product, selectedSize = null) => {
            selectedSaladProduct.value = product;
            selectedSaladSize.value =
                selectedSize ||
                    product.sizes?.find((s) => s.name === "Normale") ||
                    product.sizes?.[0] ||
                    null;
            showSaladModal.value = true;
        };
        const closeSaladModal = () => {
            showSaladModal.value = false;
            selectedSaladProduct.value = null;
            selectedSaladSize.value = null;
        };
        const openPastaModal = (product, selectedSize = null) => {
            selectedPastaProduct.value = product;
            selectedPastaSize.value =
                selectedSize ||
                    product.sizes?.find((s) => s.name === "Normale") ||
                    product.sizes?.[0] ||
                    null;
            showPastaModal.value = true;
        };
        const closePastaModal = () => {
            showPastaModal.value = false;
            selectedPastaProduct.value = null;
            selectedPastaSize.value = null;
        };
        const openPizzaModal = (product, selectedSize = null) => {
            selectedPizzaProduct.value = product;
            selectedPizzaSize.value = selectedSize;
            showPizzaModal.value = true;
        };
        const closePizzaModal = () => {
            showPizzaModal.value = false;
            selectedPizzaProduct.value = null;
            selectedPizzaSize.value = null;
        };
        const handleAddToCart = (event) => {
            const isDelivery = currentOrderType.value === "delivery";
            const correctBasePrice = isDelivery && event.size.priceLivraison
                ? parseFloat(event.size.priceLivraison) || 0
                : parseFloat(event.size.price) || 0;
            const cartItem = {
                id: generateId(),
                productId: event.product.id,
                name: event.product.name,
                image: event.product.image,
                category: event.product.category,
                selectedSize: event.size,
                quantity: event.quantity,
                basePrice: correctBasePrice,
                totalPrice: calculateItemTotal(event),
                ingredients: event.ingredients || [],
                removedIngredients: event.removedIngredients || [],
                supplements: event.supplements || [],
                additionnal: event.additionnal || [],
                notes: event.notes || "",
                localProductId: generateLocalProductId(event),
            };
            if (store) {
                store.dispatch("cart/addToCart", { item: cartItem });
            }
            closeAllModals();
        };
        const closeAllModals = () => {
            closeProductModal();
            closeSaladModal();
            closePastaModal();
            closePizzaModal();
        };
        const handleUpdateQuantity = async (itemId, quantity) => {
            if (store) {
                if (quantity > 0) {
                    await store.dispatch("cart/updateQuantity", { itemId, quantity });
                }
                else {
                    const item = cart.value.find((item) => item.localProductId === itemId);
                    if (item) {
                        await store.dispatch("cart/removeFromCart", item);
                    }
                }
            }
        };
        const handleRemoveItem = (itemId) => {
            const item = cart.value.find((item) => item.localProductId === itemId);
            if (item && store) {
                store.dispatch("cart/removeFromCart", item);
            }
        };
        const handlePlaceOrder = () => {
        };
        const closeProductModal = () => {
            showProductModal.value = false;
            selectedProduct.value = null;
        };
        const normalizeIsActive = (value) => {
            if (value === true || value === "true")
                return true;
            if (value === false || value === "false")
                return false;
            const numericValue = Number(value);
            if (!Number.isNaN(numericValue)) {
                return numericValue === 1;
            }
            return Boolean(value);
        };
        const handleDiversItem = (item) => {
            const diversProduct = {
                id: `divers-${Date.now()}`,
                name: item.name,
                description: "Article Divers / Hors Menu",
                image: "/imgs/products/default-product.png",
                category: "divers",
                sizes: [],
                ingredients: [],
                baseIngredients: [],
                supplements: [],
                isAvailable: true,
                isPopular: false,
                type: "DIVERS",
                withoutGluten: false,
                additionnal: [],
                ingredientsBaseNames: [],
                categorieID: { id: "divers", name: "Divers" },
            };
            const diversSize = {
                id: `size-divers-${Date.now()}`,
                name: "Unique",
                size: "Unique",
                price: item.price.toString(),
                priceLivraison: item.price.toString(),
                position: 1,
                created_at: new Date().toISOString(),
            };
            handleAddToCart({
                product: diversProduct,
                size: diversSize,
                quantity: 1,
                ingredients: [],
                supplements: [],
                notes: "",
            });
            toast.success(t('pos.itemAdded') || 'Article ajouté au panier');
        };
        const fetchCategories = async () => {
            isLoading.value = true;
            try {
                let transformedCategories = [];
                // Primary API: fetch categories scoped to this restaurant
                // Requires restaurantID to be set — guard against fetching global categories
                if (!restaurantID.value) {
                    console.warn("[POS] fetchCategories: restaurantID not ready, skipping fetch.");
                    return;
                }
                let primarySucceeded = false;
                try {
                    const response = await getActiveCategories(restaurantID.value, 1, 50);
                    if (response.code === 200) {
                        const categoriesList = response.data?.items ?? [];
                        if (categoriesList.length > 0) {
                            transformedCategories = categoriesList.map((category) => ({
                                id: category.id,
                                name: category.name,
                                description: category.description || "",
                                image: category.icone || "/images/default-category.jpg",
                                isActive: normalizeIsActive(category.isActive),
                                ordered: category.ordered ?? category.position ?? 0,
                                display_sizes: category.display_sizes,
                                prio: category.prio,
                                is_recommended: category.is_recommended,
                                restaurantId: category.restaurantId,
                                icone: category.icone,
                            }));
                            primarySucceeded = true;
                        }
                    }
                }
                catch (primaryError) {
                    console.warn("[POS] fetchCategories: primary API failed, trying fallback.", primaryError);
                }
                // Fallback: only if primary API returned nothing
                if (!primarySucceeded) {
                    if (userRole.value === UserRole.FRANCHISE) {
                        const response = (await listeCategorieActive(1, "0"));
                        if (response.code === 200 && response.data?.items) {
                            transformedCategories = response.data.items.map((category) => ({
                                id: category.id,
                                name: category.name,
                                description: category.description || "",
                                image: category.icone || "/images/default-category.jpg",
                                isActive: normalizeIsActive(category.isActive),
                                ordered: category.ordered || 0,
                                display_sizes: category.display_sizes,
                                prio: category.prio,
                                is_recommended: category.is_recommended,
                                restaurantId: category.restaurantId,
                                icone: category.icone,
                            }));
                        }
                    }
                    else {
                        const response = await listeRestaurantCategorie(1, "0");
                        if (response.code === 200 && response.data?.items) {
                            transformedCategories = response.data.items.map((item) => {
                                const category = item.category;
                                return {
                                    id: category.id,
                                    name: category.name,
                                    description: category.description || "",
                                    image: category.icone || "/images/default-category.jpg",
                                    isActive: normalizeIsActive(category.isActive),
                                    ordered: category.ordered || 0,
                                    display_sizes: category.display_sizes,
                                    prio: category.prio,
                                    is_recommended: category.is_recommended,
                                    restaurantId: category.restaurantId,
                                    icone: category.icone,
                                };
                            });
                        }
                    }
                }
                if (transformedCategories.length === 0) {
                    toast.error(t('pos.noCategoriesFound'));
                    return;
                }
                const sortedCategories = transformedCategories.sort((a, b) => Number(a.ordered) - Number(b.ordered));
                categories.value = sortedCategories;
                const sortedActiveCategories = sortedCategories.filter((category) => category.isActive);
                const defaultCategory = sortedActiveCategories[0] ?? sortedCategories[0] ?? null;
                if (defaultCategory) {
                    selectedCategory.value = defaultCategory.id;
                    await fetchProducts(defaultCategory.id);
                }
            }
            catch (error) {
                toast.error(t('pos.errorLoadingCategories'));
            }
            finally {
                isLoading.value = false;
            }
        };
        const mapProductData = (product, categoryId) => {
            let imageUrl = ""; // We will handle fallback below
            try {
                if (product.image_urls) {
                    if (Array.isArray(product.image_urls)) {
                        imageUrl = product.image_urls.length > 0 ? product.image_urls[0] : "";
                    }
                    else if (typeof product.image_urls === "string") {
                        const parsedImages = JSON.parse(product.image_urls);
                        if (Array.isArray(parsedImages) && parsedImages.length > 0) {
                            imageUrl = parsedImages[0];
                        }
                    }
                }
            }
            catch (error) {
                if (product.image_urls && typeof product.image_urls === "string") {
                    const cloudinaryMatch = product.image_urls.match(/https:\/\/res\.cloudinary\.com\/[^"]+/);
                    if (cloudinaryMatch) {
                        imageUrl = cloudinaryMatch[0];
                    }
                }
            }
            // Fallback to the working default image if no URL is found
            if (!imageUrl) {
                // using the same fallback as in VabeneProductList
                imageUrl = require("@/assets/images/icon/jpg.png");
            }
            let additionnalOptions = [];
            if (Array.isArray(product.additionnal)) {
                additionnalOptions = product.additionnal;
            }
            else if (product.additionnal && typeof product.additionnal === 'string') {
                additionnalOptions = parsePhpSerializedArray(product.additionnal);
                if (additionnalOptions.length === 0) {
                    try {
                        const parsed = JSON.parse(product.additionnal);
                        if (Array.isArray(parsed)) {
                            additionnalOptions = parsed.filter((item) => (typeof item === "string" && item.trim().length > 0) || (item && typeof item === "object"));
                        }
                    }
                    catch (jsonError) { }
                }
            }
            const effectiveCategoryId = categoryId || product.category_id || product.categoryId;
            const category = categories.value.find((c) => c.id === effectiveCategoryId);
            return {
                ...product,
                sizes: (product.variations || product.productSizes || [])
                    .filter((variation) => normalizeIsActive(variation.isActive))
                    .map((variation) => ({
                    id: variation.id,
                    name: variation.size,
                    size: variation.size,
                    description: variation.description,
                    price: variation.takeawayPrice || variation.price || "0",
                    priceLivraison: variation.deliveryPrice || variation.priceLivraison || variation.price || "0",
                    isActive: variation.isActive,
                    position: variation.position,
                })),
                image: imageUrl,
                isActive: normalizeIsActive(product.isActive),
                additionnal: additionnalOptions,
                categorieID: {
                    id: effectiveCategoryId,
                    name: product.category_name || category?.name,
                    prio: category?.prio,
                    display_sizes: category?.display_sizes,
                    is_recommended: category?.is_recommended,
                },
            };
        };
        const fetchProducts = async (categoryId) => {
            if (!categoryId)
                return;
            isLoadingProducts.value = true;
            try {
                let extractedProducts = [];
                try {
                    const response = await getProductsByCategory(categoryId, 1, 50, locale.value, restaurantID.value || undefined);
                    if (response.code === 200) {
                        const rawData = response.data?.data || response.data;
                        const productsList = Array.isArray(rawData) ? rawData : (rawData?.items || rawData?.data || []);
                        extractedProducts = productsList.map((p) => mapProductData(p, categoryId));
                    }
                    else {
                        throw new Error(`API getProductsByCategory échouée: ${response.message}`);
                    }
                }
                catch (newApiError) {
                    const response = (await listeRestaurantProduct(1, "0", categoryId));
                    if (response.code === 200 && response.data?.items) {
                        extractedProducts = response.data.items.map((item) => mapProductData(item.product, categoryId));
                    }
                    else {
                        throw new Error(`API listeRestaurantProduct échouée: ${response.message}`);
                    }
                }
                const activeProducts = extractedProducts.filter((product) => {
                    return product.isActive;
                });
                if (activeProducts.length === 0) {
                    toast.warning(t('pos.noActiveProductsFound'));
                }
                const sortedProducts = activeProducts.sort((a, b) => {
                    const positionA = a.position ?? 0;
                    const positionB = b.position ?? 0;
                    return positionA - positionB;
                });
                products.value = sortedProducts;
            }
            catch (error) {
                console.error("❌ " + t('messages.error.loadProductsFailed'), error);
                toast.error(t('pos.errorLoadingProducts'));
                products.value = [];
            }
            finally {
                isLoadingProducts.value = false;
            }
        };
        const performSearch = async (query) => {
            if (!restaurantID.value)
                return;
            isLoadingProducts.value = true;
            isSearching.value = true;
            try {
                const response = await searchActiveProducts(restaurantID.value, query, 1, 100, locale.value);
                if (response.code === 200) {
                    const items = response.data?.items || [];
                    products.value = items
                        .map((p) => mapProductData(p))
                        .filter((p) => p.isActive)
                        .sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
                    if (products.value.length === 0) {
                        toast.info(t('pos.noProductsFound'));
                    }
                }
            }
            catch (error) {
                console.error("Search error:", error);
                toast.error(t('pos.errorSearchingProducts'));
            }
            finally {
                isLoadingProducts.value = false;
            }
        };
        watch(searchQuery, (newQuery) => {
            if (searchTimeout)
                clearTimeout(searchTimeout);
            if (newQuery.length >= 3) {
                searchTimeout = setTimeout(() => {
                    performSearch(newQuery);
                }, 400);
            }
            else if (newQuery.length === 0) {
                if (isSearching.value) {
                    isSearching.value = false;
                    if (selectedCategory.value) {
                        fetchProducts(selectedCategory.value);
                    }
                    else if (categories.value.length > 0) {
                        selectedCategory.value = categories.value[0].id;
                        fetchProducts(selectedCategory.value);
                    }
                }
            }
        });
        const fetchIngredients = async () => {
            isLoadingIngredients.value = true;
            try {
                const response = (await getAllIngredients(1, 1000, undefined, undefined, undefined, restaurantID.value || undefined, true));
                if (response.code === 200) {
                    const ingredientsData = response.data?.data || response.data?.items || [];
                    ingredients.value = Array.isArray(ingredientsData) ? ingredientsData : [];
                }
            }
            catch (error) {
                console.error(t('messages.error.loadIngredientsFailed'), error);
                toast.error(t('pos.errorLoadingIngredients'));
                ingredients.value = [];
            }
            finally {
                isLoadingIngredients.value = false;
            }
        };
        const generateId = () => {
            return Date.now().toString() + Math.random().toString(36).substr(2, 9);
        };
        const generateLocalProductId = (event) => {
            const baseId = `${event.product.id}_${event.size.id}`;
            const ingredientsHash = event.ingredients
                .filter((ing) => !ing.isDefault && ing.quantity > 0)
                .map((ing) => `${ing.id}_${ing.quantity}`)
                .sort()
                .join("_");
            const supplementsHash = event.supplements
                .filter((sup) => sup.quantity > 0)
                .map((sup) => `${sup.id}_${sup.quantity}`)
                .sort()
                .join("_");
            return `${baseId}_${ingredientsHash}_${supplementsHash}`;
        };
        const calculateItemTotal = (event) => {
            const item = {
                selectedSize: {
                    price: event.size.price,
                    priceLivraison: event.size.priceLivraison,
                },
                ingredients: event.ingredients,
                supplements: event.supplements,
            };
            const totalPrice = calculateItemTotalPrice(item, currentOrderType.value);
            return totalPrice * event.quantity;
        };
        const initializeUserData = () => {
            const storedRole = localStorage.getItem(UserGeneralKey.USER_ROLE);
            const storedRestaurantID = localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID);
            if (storedRole) {
                userRole.value = storedRole;
            }
            if (storedRestaurantID) {
                restaurantID.value = storedRestaurantID;
            }
        };
        const openNewOrderModal = (transactionReference) => {
            newOrderTransactionReference.value = transactionReference;
            showNewOrderModal.value = true;
        };
        const closeNewOrderModal = () => {
            showNewOrderModal.value = false;
            newOrderTransactionReference.value = "";
        };
        const handleNewOrderReceived = (event) => {
            const orderData = event.detail;
            if (orderData?.order?.transactionReference) {
                openNewOrderModal(orderData.order.transactionReference);
            }
        };
        onMounted(async () => {
            initializeUserData();
            if (store) {
                store.dispatch("cart/loadFromStorage");
                store.dispatch("features/loadFromStorage");
            }
            await Promise.all([fetchCategories(), fetchIngredients()]);
            await initWalkthrough();
            window.addEventListener("new-order-received", handleNewOrderReceived);
        });
        const initWalkthrough = async () => {
            const isTourCompleted = localStorage.getItem("pos_walkthrough_completed");
            if (isTourCompleted === "true")
                return;
            if (userRole.value !== UserRole.RESTAURANT)
                return;
            if (restaurantID.value) {
                try {
                    const response = await getRestaurantDetails(restaurantID.value);
                    if (response.code === 200 && response.data) {
                        const restaurant = response.data;
                        if (!restaurant.enable_pos_walkthrough && !restaurant.enablePosWalkthrough) {
                            return;
                        }
                    }
                }
                catch (error) {
                    console.error("Error fetching restaurant details for walkthrough", error);
                    return;
                }
            }
            const driverObj = driver({
                showProgress: true,
                nextBtnText: t('common.next') || "Suivant",
                prevBtnText: t('common.previous') || "Précédent",
                doneBtnText: t('common.done') || "Terminer",
                steps: [
                    {
                        element: "#step-pos-search",
                        popover: {
                            title: "Recherche Rapide",
                            description: "Trouvez facilement un produit en saisissant son nom ici.",
                            side: "bottom",
                            align: "start",
                        },
                    },
                    {
                        element: "#step-pos-categories",
                        popover: {
                            title: "Catégories",
                            description: "Naviguez entre les différentes sections de votre menu pour une sélection rapide.",
                            side: "bottom",
                            align: "start",
                        },
                    },
                    {
                        element: "#step-pos-products",
                        popover: {
                            title: "Vos Produits",
                            description: "Cliquez sur un produit pour l'ajouter ou pour le personnaliser (taille, ingrédients).",
                            side: "top",
                            align: "start",
                        },
                    },
                    {
                        element: "#step-pos-invoice",
                        popover: {
                            title: "Panier & Validation",
                            description: "Gérez votre commande en cours et validez-la ici.",
                            side: "left",
                            align: "start",
                        },
                    },
                    {
                        element: "#step-sidebar-sales",
                        popover: {
                            title: "Historique",
                            description: "Retrouvez vos commandes passées dans la section 'Ventes' du menu.",
                            side: "right",
                            align: "start",
                        },
                    },
                ],
                onDestroyed: () => {
                    localStorage.setItem("pos_walkthrough_completed", "true");
                },
            });
            setTimeout(() => {
                driverObj.drive();
            }, 1000);
        };
        onUnmounted(() => {
            window.removeEventListener("new-order-received", handleNewOrderReceived);
        });
        watch(currentOrderType, (newOrderType, oldOrderType) => { }, {
            immediate: false,
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("main", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "search-icon" }, "🔍", -1)),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchQuery).value = $event)),
                                type: "text",
                                id: "step-pos-search",
                                placeholder: _unref(t)('pos.searchMenuPlaceholder'),
                                class: "search-input"
                            }, null, 8, _hoisted_5), [
                                [_vModelText, searchQuery.value]
                            ])
                        ])
                    ]),
                    _createVNode(CategoryNavigation, {
                        id: "step-pos-categories",
                        categories: categories.value,
                        "selected-category": isSearching.value ? '' : selectedCategory.value,
                        "is-loading": isLoading.value,
                        onCategoryChange: handleCategoryChange
                    }, null, 8, ["categories", "selected-category", "is-loading"]),
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(ProductMenu, {
                            id: "step-pos-products",
                            category: selectedCategory.value,
                            "search-query": searchQuery.value,
                            products: products.value,
                            "is-loading": isLoadingProducts.value,
                            ingredients: ingredients.value,
                            onAddToCart: handleAddToCart,
                            onCustomizeProduct: handleCustomizeProduct,
                            onCreatePizza: handleCreatePizza,
                            onAddDiversItem: handleDiversItem
                        }, null, 8, ["category", "search-query", "products", "is-loading", "ingredients"])
                    ])
                ]),
                _createElementVNode("aside", _hoisted_7, [
                    _createVNode(OrderInvoice, {
                        id: "step-pos-invoice",
                        cart: cart.value,
                        "order-summary": orderSummary.value,
                        categories: categories.value,
                        onUpdateQuantity: handleUpdateQuantity,
                        onRemoveItem: handleRemoveItem,
                        onPlaceOrder: handlePlaceOrder
                    }, null, 8, ["cart", "order-summary", "categories"])
                ]),
                (showProductModal.value)
                    ? (_openBlock(), _createBlock(ProductCustomizationModal, {
                        key: 0,
                        product: selectedProduct.value,
                        "initial-selected-size": selectedProductSize.value,
                        onClose: closeProductModal,
                        onAddToCart: handleAddToCart
                    }, null, 8, ["product", "initial-selected-size"]))
                    : _createCommentVNode("", true),
                (showSaladModal.value)
                    ? (_openBlock(), _createBlock(SaladCustomizationModal, {
                        key: 1,
                        product: selectedSaladProduct.value,
                        "selected-size": selectedSaladSize.value,
                        onClose: closeSaladModal,
                        onAddToCart: handleAddToCart
                    }, null, 8, ["product", "selected-size"]))
                    : _createCommentVNode("", true),
                (showPastaModal.value)
                    ? (_openBlock(), _createBlock(PastaCustomizationModal, {
                        key: 2,
                        product: selectedPastaProduct.value,
                        "selected-size": selectedPastaSize.value,
                        onClose: closePastaModal,
                        onAddToCart: handleAddToCart
                    }, null, 8, ["product", "selected-size"]))
                    : _createCommentVNode("", true),
                (showPizzaModal.value)
                    ? (_openBlock(), _createBlock(PizzaCustomizationModal, {
                        key: 3,
                        product: selectedPizzaProduct.value,
                        "initial-selected-size": selectedPizzaSize.value,
                        onClose: closePizzaModal,
                        onAddToCart: handleAddToCart
                    }, null, 8, ["product", "initial-selected-size"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
